module.exports = __webpack_public_path__ + "img/8.31ef6e86.jpg";